if (!customElements.get('load-more-products')) {
  class LoadMoreProducts {
    static init() {
      document.addEventListener('click', (e) => {
        const button = e.target.closest('[data-load-more-button]');
        if (!button) return;
        e.preventDefault();
        LoadMoreProducts.load(button);
      });

      LoadMoreProducts.initAutoLoad();
    }

    static load(button) {
      if (button.hasAttribute('disabled')) return Promise.resolve();

      const url = button.dataset.nextUrl;
      const gridId = button.dataset.gridId;
      const grid = document.getElementById(gridId);
      const wrapper = button.closest('[data-load-more-id]');
      const sectionId = wrapper ? wrapper.dataset.loadMoreId : null;
      if (!url || !grid || !sectionId) return Promise.resolve();

      button.setAttribute('disabled', 'disabled');
      button.classList.add('loading');

      const separator = url.includes('?') ? '&' : '?';
      const fetchUrl = `${url}${separator}section_id=${sectionId}`;

      return fetch(fetchUrl)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const newUl = html.querySelector('ul#product-grid');
          const currentUl = grid.tagName === 'UL' ? grid : grid.querySelector('ul#product-grid');

          if (newUl && currentUl) {
            Array.from(newUl.children).forEach((child) => currentUl.appendChild(child));
          }

          const newButton = html.querySelector('[data-load-more-button]');

          if (newButton && newButton.dataset.nextUrl) {
            button.dataset.nextUrl = newButton.dataset.nextUrl;
            button.removeAttribute('disabled');
            button.classList.remove('loading');
            LoadMoreProducts.reobserve(wrapper);
          } else {
            LoadMoreProducts.unobserve(wrapper);
            wrapper.remove();
          }
        })
        .catch((err) => {
          console.error('Load more error:', err);
          button.removeAttribute('disabled');
          button.classList.remove('loading');
        });
    }

    /* ---------- Infinite scroll ---------- */

    static initAutoLoad() {
      if (!('IntersectionObserver' in window)) return;
      // Respect data-saver users: fall back to the button.
      if (navigator.connection && navigator.connection.saveData) return;

      LoadMoreProducts.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const button = entry.target.querySelector('[data-load-more-button]');
            if (button) LoadMoreProducts.load(button);
          });
        },
        { rootMargin: '0px 0px 400px 0px' }
      );

      LoadMoreProducts.observeAll();

      // Facets / sorting replace #ProductGridContainer's content, re-rendering the wrapper.
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        new MutationObserver(() => LoadMoreProducts.observeAll()).observe(container, { childList: true });
      }
    }

    static observeAll() {
      if (!LoadMoreProducts.observer) return;
      document.querySelectorAll('[data-load-more-auto]:not([data-load-more-observed])').forEach((wrapper) => {
        wrapper.setAttribute('data-load-more-observed', '');
        LoadMoreProducts.observer.observe(wrapper);
      });
    }

    // Re-observing forces a fresh intersection check so a still-visible
    // sentinel keeps loading until it scrolls out of range.
    static reobserve(wrapper) {
      if (!LoadMoreProducts.observer || !wrapper || !wrapper.hasAttribute('data-load-more-auto')) return;
      LoadMoreProducts.observer.unobserve(wrapper);
      LoadMoreProducts.observer.observe(wrapper);
    }

    static unobserve(wrapper) {
      if (LoadMoreProducts.observer && wrapper) LoadMoreProducts.observer.unobserve(wrapper);
    }
  }

  window.LoadMoreProducts = LoadMoreProducts; // used by mh-scroll-restore.js
  LoadMoreProducts.init();
  customElements.define('load-more-products', class extends HTMLElement {});
}
